import { LocationStrategy } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseService } from "src/app/services/base.service";
import { IQuadroAuxiliar } from "../model/matriz-risco-controle.model";
import { IBaseModel } from "src/app/models/base.model";

@Injectable({
    providedIn: 'root',
})
export class QuadroAuxiliarService extends BaseService {


    constructor(httpClient: HttpClient, locationStrategy: LocationStrategy) {
        super(httpClient, locationStrategy);
    }

    public obter(): Promise<IBaseModel<IQuadroAuxiliar[]>> {
        return this.httpClient
            .get<IBaseModel<IQuadroAuxiliar[]>>(`${this.apiBaseUrl}/quadroAuxiliar/obter`)
            .toPromise();
    }
}